import React, { useState } from 'react';
import { addDays, formatDate } from "../../../Utis/GlobalFunctions";
import axios from "axios";
import Swal from 'sweetalert2';
import CircularLoader from "../../../Component/CircularLoader";

const PrePrimary = () => {
    const [currentDate] = useState(new Date());
    const newDate = addDays(currentDate, 3);
    const [loading, setLoading] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false); // ✅ NEW STATE

    const [credentials, setCredentails] = useState({
        username: "HGS_API",
        password: "Live@ha25",
        clientId: "zBhibIiWj86sIk1",
        clientSecret: "dn01WXsAtsmgOjJ"
    });

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        amount: '3,000.00',
        classNumber: "Class-Nursery",
        candidateName: '',
        bFormNumber:"",
    });

    const [errors, setErrors] = useState({

    });

    let  payload;

    payload = [
        {
            MerchantId: credentials?.username
        },
        {
            OrderNumber: `${+currentDate}`,
            OrderAmount: parseFloat(formData?.amount.replace(/,/g, '')),
            OrderDueDate: formatDate(newDate),
            OrderType: "Service",
            IssueDate: formatDate(currentDate),
            OrderExpireAfterSeconds: "0",
            CustomerName: formData?.candidateName,
            CustomerMobile: formData?.phoneNumber ?? "",
            CustomerEmail: formData?.email,
            CustomerAddress: formData?.address,
            BillDetail01: [
                {
                    classNumber: formData?.classNumber,
                    candidateName:formData?.candidateName,
                    bFormNumber:formData?.BFormNumber
                }
            ]
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        validateField(name, value);
    };

    const validateField = (name, value) => {
        let fieldError = {};
        switch (name) {
            case "name":
                fieldError.name = value ? "" : "Name is required.";
                break;
                case "bFormNumber":
                fieldError.bFormNumber = value ? "" : "Candidate's B-Form # is required.";
                break;
            case "candidateName":
                fieldError.candidateName = value ? "" : "Candidate Name is required.";
                break;
            case "email":
                if (!value) fieldError.email = "Email is required.";
                else if (!/\S+@\S+\.\S+/.test(value))
                    fieldError.email = "Email address is invalid.";
                else fieldError.email = "";
                break;
            case "amount":
                fieldError.amount = value ? "" : "Amount is required.";
                break;
            default:
                break;
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            ...fieldError,
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.bFormNumber) newErrors.bFormNumber = "Candidate's B-Form # is required.";
        if (!formData.candidateName) newErrors.name = "Candidate Name is required.";
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }
        if (!formData.amount) newErrors.amount = "Amount is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const getAuthToken = async (clientId, clientSecret) => {
        const tokenResponse = await axios.post(`${process.env.REACT_APP_PAYPRO_LIVEAPI}/auth`, {
            clientid: clientId,
            clientsecret: clientSecret,
        });
        return tokenResponse.data.token;
    };

    const payproCreateOrder = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        if (!termsAccepted) {
            Swal.fire({
                icon: "warning",
                title: "Please accept the Terms & Conditions",
                showConfirmButton: false,
                timer: 1500
            });
            return;
        }

        try {
            setLoading(true);
            const token = await getAuthToken(credentials.clientId, credentials.clientSecret);
            const headers = { 'token': token, 'Content-Type': 'application/json' };
            const url = `${process.env.REACT_APP_PAYPRO_LIVEAPI}/create-order`;
            const response = await axios.post(url, payload, { headers });

            if (response.data?.data[0].Status === "03") {
                await Swal.fire({
                    icon: "error",
                    title: response?.data?.data[1]?.Description,
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                const marketplaceUrl = response.data?.data[1]?.Click2Pay;
                await Swal.fire({
                    icon: "success",
                    title: "Redirecting to Marketplace",
                    showConfirmButton: false,
                    timer: 1500
                });
                window.top.location.href = marketplaceUrl + "&callback_url=https://habibschools.edu.pk/hgs/success-page-for-nursery/";
            }
        } catch (error) {
            console.error('Error creating order:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-11/12 lg:w-[75%] md:w-[80%] bg-white border-4 rounded-lg shadow relative m-auto">
        <form className="p-6 space-y-6" onSubmit={payproCreateOrder}>
                <div className="w-full font-medium  flex justify-center items-center  ">
                    <h2 className="text-4xl">Payee's Details</h2>
                </div>
                <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Name <span>*</span></label>
                        <input
                            type="text"
                            name="name"
                            value={formData?.name}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Full Name"
                        />
                        {errors.name && <p className="text-red-600 text-sm">{errors.name}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Email <span>*</span></label>
                        <input
                            type="email"
                            name="email"
                            value={formData?.email}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Your Email Address"
                        />
                        {errors.email && <p className="text-red-600 text-sm">{errors.email}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Mobile Number <span>*</span></label>
                        <input
                            type="tel"
                            name="phoneNumber"
                            value={formData?.phoneNumber}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Phone Number"
                        />
                        {errors.phoneNumber && <p className="text-red-600 text-sm">{errors.phoneNumber}</p>}
                    </div>


                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Candidate Name (same as Registration Form) <span>*</span></label>
                        <input
                            type="text"
                            name="candidateName"
                            value={formData?.candidateName}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Candidate Name"
                        />
                        {errors.candidateName && <p className="text-red-600 text-sm">{errors.candidateName}</p>}
                    </div>

                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Candidate's B-Form #<span>*</span></label>
                        <input
                            type="text"
                            name="bFormNumber"
                            value={formData?.bFormNumber}
                            onChange={handleChange}
                            className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Candidate's B-Form #"
                        />
                        {errors?.bFormNumber && <p className="text-red-600 text-sm">{errors?.bFormNumber}</p>}
                    </div>



                    <div className="col-span-6 sm:col-span-3">
                        <label className="text-md font-medium text-gray-900 block mb-2">Amount <span>*</span></label>
                        <input
                            type="text"
                            name="amount"
                            disabled={true}
                            value={formData?.amount}
                            onChange={handleChange}
                            className="cursor-not-allowed shadow-sm bg-gray-200 border font-bold border-gray-300 text-[#5F0C0C] sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                            placeholder="Amount"
                        />
                        {errors.amount && <p className="text-red-600 text-sm">{errors.amount}</p>}
                    </div>
                </div>

                {/* ✅ Terms & Conditions Checkbox */}
                <div className="flex items-center space-x-2 mt-4">
                    <input
                        id="terms"
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                        className="w-4 h-4 accent-[#5F0C0C] border-gray-300 rounded focus:ring-[#5F0C0C]"
                    />


                    <label htmlFor="terms" className="text-sm text-gray-700">
                        I agree to the registration fee of Rs. 3,000/- is non-refundable
                    </label>
                </div>

                <div className="flex items-center justify-center">
                    <button
                        type="submit"
                        disabled={!termsAccepted || loading}
                        className={`flex items-center gap-1 py-2 px-10 text-white font-medium rounded-lg text-lg 
                            ${termsAccepted && !loading
                            ? "bg-[#5F0C0C] hover:bg-[#5F0C0C] focus:ring-white-200"
                            : "bg-gray-400 cursor-not-allowed"}`}
                    >
                        Pay {loading ? <CircularLoader /> : null}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PrePrimary;
